module.exports = __webpack_public_path__ + "static/media/readingtunic.c5d82bac.jpg";